module.exports = __webpack_public_path__ + "images/accents/accent-strawberries@2x-2b7e34688a0014436224fcd173f67269.webp";